export const getSpecialtyName = data => {
  if (data.specialty) return data.specialty.displayName;
  return 'N/A';
};

export const getSpecialtyCode = data => (data.specialty ? data.specialty.code : null);
